export const PPL_COUNTRY_CODES = [
  'US',
  'CA',
  'GB',
  'IE',
  'NL',
  'SE',
  'CH',
  'DK',
  'NO',
  'FI',
  'BE',
  'AE',
  'ZA',
  'AU',
  'NZ',
] as const;
